import Resources from '@/pages/Resources';

export default function ResourcesSection() {
  return <Resources />;
}
